import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import {
  tenDigitRegexStartingWith9,
  EMAIL_REGEX,
} from "../../helpers/regexHelper";
import toast from "react-hot-toast";
import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import { createCollector } from "../../redux/actions/collector";

const initialErrors = {
  errorName: "",
  errorEmail: "",
  errorUsername: "",
  errorPassword: "",
  errorPhone: "",
};
const initialValues = {
  name: "",
  email: "",
  username: "",
  password: "",
  phone: "",
};

function AddCollector() {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);
  const { name, email, username, password, phone } = values;
  const { errorName, errorEmail, errorUsername, errorPassword, errorPhone } =
    errors;

  const handleSuccess = () => {
    setValues(initialValues);
    setIsSubmitting(false);
    toast.success("Collector has successfully been created");
  };
  const handleFaliure = (e) => {
    // alert("Login failed");
    toast.error(e.response ? e.response.data.message : e.message);
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const errorHandler = (key, val) => {
    setErrors((current) => {
      return { ...current, [key]: val };
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(name)) {
      hasErrors = true;
      errorHandler("errorName", "Name cannot be empty");
    } else {
      errorHandler("errorName", "");
    }
    if (!/\S/.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Email cannot be empty");
    } else if (!EMAIL_REGEX.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Enter a valid email");
    } else {
      errorHandler("errorEmail", "");
    }
    if (!/\S/.test(username)) {
      hasErrors = true;
      errorHandler("errorUsername", "Username cannot be empty");
    } else {
      errorHandler("errorUsername", "");
    }
    if (!/\S/.test(password)) {
      hasErrors = true;
      errorHandler("errorPassword", "Password cannot be empty");
    } else if (password.length < 6) {
      hasErrors = true;
      errorHandler(
        "errorPassword",
        "Password should be minimum of 6 characters long"
      );
    } else {
      errorHandler("errorPassword", "");
    }
    if (!/\S/.test(phone)) {
      hasErrors = true;
      errorHandler("errorPhone", "Phone cannot be empty");
    } else if (!tenDigitRegexStartingWith9.test(phone)) {
      hasErrors = true;
      errorHandler(
        "errorPhone",
        "Phone should be of 10 digits starting with 9"
      );
    } else {
      errorHandler("errorPhone", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setErrors(initialErrors);
      setIsSubmitting(true);
      const data = {
        name,
        email,
        mobileNumber: phone,
        username,
        password,
      };
      dispatch(createCollector(data, handleSuccess, handleFaliure));
    }
  };

  return (
    <Col md={12} className={"mt-3"}>
      <Card border="light" className="bg-white shadow-sm mb-4 p-0">
        <Card.Body>
          <h5 className="mb-4">Create a Collectors Account</h5>

          <Form onSubmit={submitHandler}>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="name"
                    onChange={onChange}
                    value={name}
                    size="sm"
                  />
                  {errorName !== "" && (
                    <Form.Text className="text-danger">{errorName}</Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder=""
                    name="email"
                    onChange={onChange}
                    value={email}
                    size="sm"

                  />
                  {errorEmail !== "" && (
                    <Form.Text className="text-danger">{errorEmail}</Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="username"
                    onChange={onChange}
                    value={username}
                    size="sm"

                  />
                  {errorUsername !== "" && (
                    <Form.Text className="text-danger">
                      {errorUsername}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="password" className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faUnlockAlt} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="password"
                      placeholder=""
                      name="password"
                      onChange={onChange}
                      value={password}
                    size="sm"

                    />
                  </InputGroup>
                  {errorPassword !== "" && (
                    <Form.Text className="text-danger">
                      {errorPassword}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="phone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    placeholder=""
                    name="phone"
                    onChange={onChange}
                    value={phone}
                    size="sm"

                  />
                  {errorPhone !== "" && (
                    <Form.Text className="text-danger">{errorPhone}</Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                className="m-1"
                onClick={submitHandler}
                disabled={isSubmitting}
              >
                {isSubmitting === true ? (
                  <Spinner animation="border" />
                ) : (
                  "Create Collector"
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default AddCollector;
